var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "not-found" } },
    [
      _vm.isFit
        ? [
            _c("dd-header"),
            _vm._v(" "),
            _c("main", [_vm._v("\n      ページが見つかりません。\n    ")])
          ]
        : _vm.isDC
          ? [
              _c("dd-dc-header"),
              _vm._v(" "),
              _c("main", { staticClass: "padding" }, [
                _vm._v("\n      ページが見つかりません。\n    ")
              ])
            ]
          : _vm.isKG
            ? [
                _c("dd-kg-header"),
                _vm._v(" "),
                _c("main", { staticClass: "padding" }, [
                  _vm._v("\n      ページが見つかりません。\n    ")
                ])
              ]
            : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a6af43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a6af43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/NotFound.vue
// module id = null
// module chunks = 